module.exports = __webpack_public_path__ + "static/media/fPODER  EL A ELLA  MINUTA.9bafa97b.pdf";